import {Inject, Injectable} from "@angular/core";
import {BehaviorSubject, catchError, firstValueFrom, Observable, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import { TokenExpiredTimerService } from "../token-expired-timer/token-expired-timer.service";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import {environment} from "../../../../environments/environment";
import jwt_decode from "jwt-decode";
import { NotificationConnectionService } from "../notifications/notification-connection.service";

@Injectable({providedIn: "root"})
export class AuthenticationService {
  private baseEndPoint: string;

  private ipAddress: string = "";
  private body: any;
  authCloseSessionHeaders: HttpHeaders = new HttpHeaders()
  private userPhrase = new BehaviorSubject<any>(null)
  userPhrase$ = this.userPhrase.asObservable()
  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenExpiredTimerService: TokenExpiredTimerService,
    private notificationConnectionService: NotificationConnectionService
    ) {
    this.baseEndPoint = environment.apiTokenUrl;
    this.getIP();
  }

  public validateToken(token: string): Observable<any> {
    return this.http.post<any>(`${this.baseEndPoint}/token/validate`, {
      token: token,
      publicKey: sessionStorage.getItem(StorageKeysEnum.PUBLIC_KEY),
    }).pipe(catchError(this.errorHandler));
  }

  public querySecret(token: string): Observable<any> {
    return this.http.post<any>(`${this.baseEndPoint}/token/secret`, {
      token
    }).pipe(catchError(this.errorHandler));
  }

  public initLogin(user: string, pass: string): Observable<any> {
    if (sessionStorage.getItem(StorageKeysEnum.COORDS)) {
      this.body = {
        usuario: user,
        password: pass,
        latitud: JSON.parse(sessionStorage.getItem(StorageKeysEnum.COORDS) as string).lat,
        longitud: JSON.parse(sessionStorage.getItem(StorageKeysEnum.COORDS) as string).lon,
        ip: this.ipAddress,
        useragent: window.navigator.userAgent
      }
    } else {
      this.router.navigate(['/login']);
    }
    return this.http.post<any>(`${this.baseEndPoint}/oauth/login`, this.body).pipe(catchError(this.errorHandler));
  }

  public loginWithWso2(user: string, samlRequest: string) {
    let body = {
      samlresponse: user,
      usuario: samlRequest
    }
    return this.http.post<any>(`${this.baseEndPoint}/oauth/wso2/login`, body).pipe(catchError(this.errorHandler));
  }

  public login(response: any, emmiter: any) {
    sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN, response.jwt);
    sessionStorage.setItem(StorageKeysEnum.REFRESH_TOKEN, response.refreshToken);
    sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN_WSO, response.wsoJwt);
    sessionStorage.setItem(StorageKeysEnum.JWT_WSO_DECODE, JSON.stringify(jwt_decode(response.wsoJwt)));
    emmiter.emit();
  }

  logOutWithoutRedirect() {
    this.tokenExpiredTimerService.enableTimer = false
    this.http.post<any>(`${this.baseEndPoint}/oauth/logout`,{
      wsoToken: sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO),
    }).subscribe({
      next: value =>{
        sessionStorage.clear();
      },
      error: err => console.log("Error logout: ", err)
    });
  }

  public async logOut() {
    this.tokenExpiredTimerService.enableTimer = false

    try {
      await firstValueFrom(this.http.post<any>(`${this.baseEndPoint}/oauth/logout`, {
        jwt: sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO),
      }))
    } catch (error) {
      console.log("Error logout: ", error)
      this.router.navigate(['/']);
      return
    }

    this.deleteSession()
    this.notificationConnectionService.closeWebsocketConnection()
    this.router.navigate(['/']);
    location.reload()
    return
    
  }

  public deleteSession() {
    sessionStorage.removeItem(StorageKeysEnum.USER_INFO);
    sessionStorage.removeItem(StorageKeysEnum.ACCESS_TOKEN);
    sessionStorage.removeItem(StorageKeysEnum.REFRESH_TOKEN);
    sessionStorage.removeItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
    sessionStorage.removeItem(StorageKeysEnum.JWT_WSO_DECODE);
    sessionStorage.removeItem(StorageKeysEnum.PUBLIC_KEY);
    sessionStorage.removeItem(StorageKeysEnum.PRIVATE_KEY);
    sessionStorage.removeItem('CONTRACTS_INFORMATION')
  }

  private getIPAddress() {
    return this.http.get("https://api.ipify.org?format=json");
  }

  private getIP() {
    this.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
      sessionStorage.setItem(StorageKeysEnum.IP, res.ip);
    });
  }


  private errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
      return throwError(() =>
        'Something bad happened; please try again later.');
    } else {
      return throwError(() => error.error);
    }
  }

  sendEmailToCloseSession(headers: HttpHeaders) {
    return this.http.get(`${this.baseEndPoint}/sessions/sendCloseSessionToken`, {
      headers
    })
  }

  validateCodeCloseSession(headers: HttpHeaders, otpCode: string) {
    return this.http.post(`${this.baseEndPoint}/sessions/close`,{otp: otpCode}, {
      headers 
    })
  }

  getAuthCloseSessionHeaders(): HttpHeaders {
    return this.authCloseSessionHeaders;
  }

  setAuthCloseSessionHeaders(headers: HttpHeaders): void {
    this.authCloseSessionHeaders = headers
  }

  setUserPhrase(data: any){
    this.userPhrase.next(data)
  }
}
